import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";

import { UPDATE_CUSTOMER_ADDRESS } from "../customer-address.queries";
import { parseParams } from "../../../helpers/clean-object";

import { UpdateCustomerAddressInput } from "../../../__generated__/globalTypes";
import {
  UpdateCustomerAddressMutation,
  UpdateCustomerAddressMutationVariables,
} from "../../../__generated__/UpdateCustomerAddressMutation";

interface IProps {
  id: number;
  onCompleted: () => any;
}

export const useUpdateCustomerAddress = ({ id, onCompleted }: IProps) => {
  const form = useForm<UpdateCustomerAddressInput>({
    mode: "all",
  });
  const [mutate, { loading }] = useMutation<
    UpdateCustomerAddressMutation,
    UpdateCustomerAddressMutationVariables
  >(UPDATE_CUSTOMER_ADDRESS, {
    refetchQueries: ["CustomerAddressesQuery", "CustomerAddressQuery"],
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          id,
          input: parseParams(input),
        },
      });

      if (data?.updateCustomerAddress?.ok) {
        onCompleted();
      } else {
        throw Error(data?.updateCustomerAddress?.error ?? "Error");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
